import { Link } from "react-router-dom";
import logoBlack from "../../assets/images/logo/logo-black.svg";

export default function LogoSection() {
	return (
		<Link to="/">
			<img src={logoBlack} alt="" />
		</Link>
	);
}
